import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React from 'react';
import { Grid } from 'semantic-ui-react';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { DEFAULT_INFINITE_SCROLL_ENABLED, DEFAULT_MOBILE_PROPS, DEFAULT_PAGINATION_PROPS, DEFAULT_TABLET_PROPS } from './PaginatedGrid.constants';
import { getGridProps, getPaginationProps, getPageSize, canSafelyServerRender } from './PaginatedGrid.utils';
import useResponsive from '../../../../hooks/use-responsive';
import { toArray } from '../../../../services/components';
import { ObjectPropsPropType } from '../../../../services/proptypes';
import { classNames } from '../../../../utils/classname';
import { EVENT_CATEGORIES } from '../../../analytics/components/Event/Event.constants';
import { EventPropType } from '../../../analytics/types';
import { ChildrenPropType } from '../../types/component';
import Pagination from '../Pagination';
import { DirectionIndicatorIconsPropType } from '../Pagination/components/PaginationIndicators/PaginationIndicators.types';
import './PaginatedGrid.css';
var defaultProps = {
  items: [],
  children: [],
  columns: 3,
  rows: 1,
  mobile: DEFAULT_MOBILE_PROPS,
  tablet: DEFAULT_TABLET_PROPS,
  pagination: DEFAULT_PAGINATION_PROPS,
  className: '',
  tight: false,
  event: {
    category: EVENT_CATEGORIES.PAGINATED_GRID_EVENT_CATEGORY
  }
};
export default function PaginatedGrid(_ref) {
  var _classNames;
  var items = _ref.items,
    children = _ref.children,
    columns = _ref.columns,
    rows = _ref.rows,
    mobile = _ref.mobile,
    tablet = _ref.tablet,
    pagination = _ref.pagination,
    className = _ref.className,
    tight = _ref.tight,
    event = _ref.event;
  var responsive = useResponsive();
  var loaded = responsive.loaded;
  var finalItems = [].concat(_toConsumableArray(toArray(items)), _toConsumableArray(toArray(children)));
  if (_isEmpty(finalItems)) {
    return null;
  }
  var gridProps = getGridProps({
    columns: columns
  }, mobile, tablet, responsive);
  var pageSize = getPageSize(finalItems, {
    columns: columns,
    rows: rows
  }, mobile, tablet, responsive);
  var _getPaginationProps = getPaginationProps(pagination),
    displayPagination = _getPaginationProps.display,
    defaultActivePage = _getPaginationProps.defaultActivePage,
    onlyPageIndicators = _getPaginationProps.onlyPageIndicators,
    directionIndicatorIcons = _getPaginationProps.directionIndicatorIcons,
    infiniteScroll = _getPaginationProps.infiniteScroll;
  var displayIndicators = finalItems.length > pageSize && displayPagination;
  var componentClass = classNames((_classNames = {
    'paginated-grid': true
  }, _defineProperty(_classNames, className, !!className), _defineProperty(_classNames, "tight", tight), _classNames));
  var infiniteScrollEnabled = _get(infiniteScroll, 'enabled', DEFAULT_INFINITE_SCROLL_ENABLED);
  var canServerRender = canSafelyServerRender(finalItems, {
    columns: columns,
    rows: rows
  }, mobile, tablet);
  return /*#__PURE__*/React.createElement("div", {
    className: componentClass
  }, /*#__PURE__*/React.createElement(Pagination, {
    pageSize: pageSize,
    items: finalItems,
    defaultActivePage: defaultActivePage,
    event: event,
    infinite: infiniteScrollEnabled
  }, /*#__PURE__*/React.createElement(Grid, gridProps, /*#__PURE__*/React.createElement(Pagination.Elements, null, function (activeItems) {
    if (!loaded && !canServerRender) {
      return null;
    }
    return activeItems.map(function (item) {
      return /*#__PURE__*/React.createElement(Grid.Column, {
        key: item.key
      }, item);
    });
  })), displayIndicators && !infiniteScrollEnabled && /*#__PURE__*/React.createElement(Pagination.Indicators, {
    onlyPageIndicators: onlyPageIndicators,
    directionIndicatorIcons: directionIndicatorIcons,
    disableIndicatorsOnLimit: true
  }), infiniteScrollEnabled && /*#__PURE__*/React.createElement(Pagination.InfiniteScrollTrigger, {
    showMoreButtonProps: _get(infiniteScroll, 'showMoreButtonProps', {})
  })));
}
PaginatedGrid.defaultProps = defaultProps;